import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ms-text-secondary NKT-P1" }




export default /*@__PURE__*/_defineComponent({
  __name: 'CoordinateCell',
  props: {
  coordinates: Array<Number>,
  color: {
    type: String,
    default: 'gray'
  }
},
  setup(__props) {

_useCssVars(_ctx => ({
  "5b6a28e8": (__props.color)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "fe fe-map-pin" }, null, -1)),
    _createTextVNode(" " + _toDisplayString(__props.coordinates !== undefined && __props.coordinates.length == 2 ? __props.coordinates[0].toFixed(2) : '') + ", " + _toDisplayString(__props.coordinates !== undefined && __props.coordinates.length == 2 ? __props.coordinates[1].toFixed(2) : ''), 1)
  ]))
}
}

})